// extracted by mini-css-extract-plugin
export default {"ToDoHeading__noDivider":"ToDoHeading_ToDoHeading__noDivider__V5Gl8","Header":"ToDoHeading_Header__0Dh0N","CompletedBlock":"ToDoHeading_CompletedBlock__8eiVj"};